module.exports = __webpack_public_path__ + "img/secondary_4x3_z16.a98bf7aa.svg";